import {combineReducers} from 'redux'
import Customizer from './customizer/reducer'
import {SessionReducer} from "../store/session/session.reducer";
import {SpeakersReducer} from "../store/speakers/speakers.reducer";
import {SessionsReducer} from "../store/sessions/sessions.reducer";
import {UserReducer} from "../store/user/user.reducer";

const reducers = combineReducers({
  Customizer,
  ...SessionReducer,
  ...SpeakersReducer,
  ...SessionsReducer,
  ...UserReducer
});

export default reducers;
